module.exports = __webpack_public_path__ + "img/b56547744ddd9a9ead33d598f15f7392.2bb4d682.png";